import clsx from 'clsx';
import { OpenAPICodeSample } from './OpenAPICodeSample';
import { OpenAPIResponseExample } from './OpenAPIResponseExample';
import { OpenAPIColumnSpec } from './common/OpenAPIColumnSpec';
import { OpenAPISummary } from './common/OpenAPISummary';
import { resolveOpenAPIContext } from './context';
/**
 * Display an interactive OpenAPI operation.
 */
export function OpenAPIOperation(props) {
    var className = props.className, data = props.data, contextInput = props.context;
    var context = resolveOpenAPIContext(contextInput);
    return (<div className={clsx('openapi-operation', className)}>
            <OpenAPISummary data={data} context={context}/>
            <div className="openapi-columns">
                <OpenAPIColumnSpec data={data} context={context}/>
                <div className="openapi-column-preview">
                    <div className="openapi-column-preview-body">
                        <OpenAPICodeSample data={data} context={context}/>
                        <OpenAPIResponseExample data={data} context={context}/>
                    </div>
                </div>
            </div>
        </div>);
}
